module.exports = __webpack_public_path__ + "img/sushidonutsoben.a36242e1.png";